import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionService } from "./services/session.service";

export class AddHeaderInterceptor implements HttpInterceptor {
  private token: string = "";
  constructor(private loginService: SessionService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.loginService.getUsertoken())
      this.token = "Bearer " + this.loginService.getUsertoken();

    const clonedRequest = req.clone({
      headers: req.headers.append("Authorization", this.token),
    });
    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/AddHeaderInterceptor.ts